__turbopack_context__.v({
  "default": "status-message-module-scss-module__7Ea3AG__default",
  "destructive": "status-message-module-scss-module__7Ea3AG__destructive",
  "root": "status-message-module-scss-module__7Ea3AG__root",
  "success": "status-message-module-scss-module__7Ea3AG__success",
  "warning": "status-message-module-scss-module__7Ea3AG__warning",
});
